import { OrderProtocolWidget } from "Order/Modules/Protocol/Widgets/OrderProtocolWidget";

type OrderProtocolTabProps = {
	orderId: number;
};

export function OrderProtocolTab({ orderId }: OrderProtocolTabProps) {
	return <OrderProtocolWidget orderId={orderId} />;
}
